import { get } from "./base";

export async function getRecommendCourse(groupId) {
    let respObj = await get("/api/course/getRecommendList",
        groupId != "0" ? { "trainCycle": groupId } : null);
    if (respObj != false) {
        // 处理接口数据
        if (respObj.trainCycle != null) {
            let cycles = [{
                "id": "0",
                "name": "全部课程"
            }, ...respObj.trainCycle];
            return { list: respObj.list, cycles };
        }
        return { list: respObj.list, "cycles": [] };
    } else {
        return {};
    }
}
